// gimme: conversations-inbox-ui 06/04/2020 c274e8ac5510b62b817eb74db200bc9802a2508d
'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import UIIcon from 'UIComponents/icon/UIIcon';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { ActionButton } from '../../thread-toolbar/components/ActionButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class ThreadDeleteButton extends Component {
  render() {
    return /*#__PURE__*/_jsxs(ActionButton, {
      onClick: this.props.onClick,
      disabled: this.props.disabled,
      children: [/*#__PURE__*/_jsx(UIIcon, {
        name: "delete",
        size: 18
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-thread-view.thread-deletion.deleteBtn"
      })]
    });
  }
}
ThreadDeleteButton.displayName = 'ThreadDeleteButton';
ThreadDeleteButton.propTypes = {
  disabled: PropTypes.bool,
  onClick: PropTypes.func.isRequired
};